module.exports = __webpack_public_path__ + "static/media/404.311cb4dd.png";